module.exports = __webpack_public_path__ + "img/part-2-title.ed77f6a1.png";